<template>
  <div id="app">
      <view-loader v-if="showViewLoader" margin-top-percentage="20"></view-loader>

      <manager-menu v-if="!showViewLoader"></manager-menu>

      <router-view v-if="!showViewLoader"/>

      <manager-footer v-if="!showViewLoader"></manager-footer>
  </div>
</template>

<script>
import ManagerMenu from '@/components/ManagerMenu.vue'
import ManagerFooter from '@/components/ManagerFooter.vue'
import ViewLoader from '@/components/ViewLoader.vue'
import Api from '@/api';

export default {
    components: {
        ManagerMenu,
        ManagerFooter,
        ViewLoader
    },

    data() {
        return {
            showViewLoader: true,
            templatLabels: null,
            loadingStartedAt: null,
            minLoadingMs: 2000,
        }
    },

    mounted() {
        this.initApp(() => {
            var timeout = 0;
            var differenceInMs = window.performance.now() - this.loadingStartedAt;

            if (differenceInMs < this.minLoadingMs) {
                timeout = this.minLoadingMs - differenceInMs;
            }

            setTimeout(() => {
                this.showViewLoader = false;
            }, timeout);
        });
    },

    methods: {
        async initApp(finishCallback) {
            this.loadingStartedAt = window.performance.now();
            await this.loadTemplateLabels();

            if (typeof finishCallback === 'function') {
                finishCallback();
            }
        },

        loadTemplateLabels() {
            let endpoint = this.$partnerEndpoint('languages/1/translations');

            return Api().get(endpoint)
                .then((response) => {
                    window.templateLabels = {};

                    for (var i = 0; i < response.data.data.length; i++) {
                        window.templateLabels[response.data.data[i].label] = response.data.data[i].text;
                    }

                    response.data.data;
                })
                .catch((error) => {
                    //
                });
        },
    },
}
</script>

<style lang="scss">
#app {
    position: absolute;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    min-height: 100%;
    min-width: 100%;
}
</style>
